// extracted by mini-css-extract-plugin
export default {"Emoji":"bbh_a bhh_i bhh_q bhh_j"};